if not App.angularApp?
    return

App.angularApp.directive 'mfClickover', ->
    return {
        # TODO: add template support
        restrict: 'A' # change to 'AE' when template is implemented
        # template: '<span></span>'
        link: (scope, ele, attrs) ->
            # default properties
            defaults =
                html: true
                container: '#bs2-container'
                trigger: 'outsideClick'

            # evaluate the specified properties
            props = scope.$eval(attrs.mfClickover)

            # create the clickover
            options = $.extend {}, defaults, props
            ele.clickover(options)

            # TODO: fix this
            # allow it to update if using a scope variable that changes
            # scope.$watch attrs.mfClickover, (val) =>

            #     # evaluate the updated properties
            #     props = scope.$eval(val)

            #     # apply them (not 100% sure this will actually work??)
            #     options = $.extend {}, defaults, props
            #     ele.clickover(options)
    }
